export const ROL_EMPRESA = "empresa";
export const ROL_ADMIN = "admin";
export const AFILIADO_ACTIVO = "ACTIVO";
export const AFILIADO_INACTIVO = "INACTIVO";
export const PERSONA_IMPORTADO = "IMPORTADO";
export const PERSONA_VERIFICAR = "A VERIFICAR";
export const PERSONA_VERIFICADO = "VERIFICADO";
export const CONCEPTO_APORTE_SINDICAL = 1;
export const CONCEPTO_FAS = 2;
export const CONCEPTO_CONTRIBUCION_FIJA = 3;
export const ESTADO_DDJJ_ANULADA = "ANULADA";
export const ESTADO_DDJJ_ACTIVA = "ACTIVA";
export const ESTADO_TICKET_VENCIDO = "VENCIDO";
export const ESTADO_TICKET_ANULADO = "ANULADO";
export const ESTADO_TICKET_PAGADO = "PAGADO";
export const ESTADO_TICKET_PENDIENTE_PAGO = "PENDIENTE DE PAGO";
export const ESTADO_TICKET_PAGO_PARCIAL = "PAGO PARCIAL";
export const MESES = [
	"Enero",
	"Febrero",
	"Marzo",
	"Abril",
	"Mayo",
	"Junio",
	"Julio",
	"Agosto",
	"Septiembre",
	"Octubre",
	"Noviembre",
	"Diciembre"
];
export const TIPO_DJ = "DJ";
export const TIPO_A_DEMANDA = "A DEMANDA";
export const ROL_COORDINADOR = "coordinador";
export const ROL_OPERADOR_AFFI = "operador afiliaciones";
export const ROL_OPERADOR_RECAUDA = "operador recaudaciones";
export const ROL_SUB_ADMIN = "sub admin";
export const ROL_BI_USER = "bi user";
export const SALARY_TYPE_DJ = "DJ";
export const SALARY_TYPE_HABERES = "Haberes";
export const ROL_SOPORTE = "soporte";
export const ESTADO_SUPPORT_TICKET_ENVIADO = "ENVIADO";
export const ESTADO_SUPPORT_TICKET_EN_PROCESO = "EN PROCESO";
export const ESTADO_SUPPORT_TICKET_RESUELTO = "RESUELTO";
export const ESTADO_SUPPORT_TICKET_CANCELADO = "CANCELADO";



// WEBPACK FOOTER //
// ./src/common/Constants.js